<template>
  <div :class="{'flex-wrap table-filter-item': label}">
    <div v-if="label" class="flex-align-center table-filter-label">{{ label }}：</div>
    <el-select
      v-model="valueBackup"
      :clearable="clearable"
      :placeholder="placeholder"
      @change="handleChange"
      :multiple="multiple"
      filterable
      :size="size"
    >
      <el-option
        v-for="item in list"
        :key="item.value"
        :label="item.name"
        :value="item.value"
      />
    </el-select>
  </div>
</template>

<script>
import { reserveStates } from '@/enums/reserveStates';

export default {
  props: {
    value: {
      type: [String, Number, Array],
      default: '',
    },
    clearable: Boolean,
    multiple: Boolean,
    size: {
      type: String,
      default: 'medium',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '请选择预约状态',
    },
    isLocationLimit: Boolean,
    disabled: Boolean,
    hasPrivate: Boolean,
  },
  data: () => ({
    valueBackup: 0,
    list: reserveStates,
  }),
  watch: {
    value(value) {
      if (this.multiple) {
        if (JSON.stringify(value) !== JSON.stringify(this.valueBackup)) this.valueBackup = value || [];
      } else {
        if (value !== this.valueBackup) {
          if (value === '') return this.valueBackup = '';
          this.valueBackup = +value || 0;
        }
      }
    },
    valueBackup(valueBackup) {
      if (this.multiple) {
        if (JSON.stringify(valueBackup) !== JSON.stringify(this.value)) this.$emit('input', valueBackup);
      } else {
        if (valueBackup !== (+this.value || '')) this.$emit('input', valueBackup);
      }
    },
  },
  methods: {
    handleChange(valueBackup) {
      this.$emit('change', valueBackup);
    },
  },
  beforeMount() {
    if (this.multiple) {
      this.valueBackup = this.value || [];
    } else {
      if (this.value === '') return this.valueBackup = '';
      this.valueBackup = +this.value || 0;
    }
  },
};
</script>
